export default (position = "", confirmationMessage = null) => ({
  open: false,
  clioUIDialogConfirm: true,

  /**
   * Reveals the dialog. If the dialog is positioned to the right, a slide-in
   * effect will be subsequently called.
   */
  openDialog() {
    this.$refs.dialog.showModal();
    this.open = true;

    if (position === "right") {
      this.slideIn();
    }
  },

  /**
   * Closes the dialog. If the dialog is positioned to the right, a slide-out
   * effect will be called first before closing the dialog. Prior to closing the
   * dialog, a JavaScript confirm prompt will be displayed if one is provided.
   */
  closeDialog() {
    if (
      !this.clioUIDialogConfirm ||
      !confirmationMessage ||
      confirm(confirmationMessage)
    ) {
      if (position === "right") {
        this.slideOut();
      } else {
        this.$refs.dialog.close();
        this.open = false;
      }
    }
  },

  /**
   * Dismisses the dialog and emits an event to notify the parent component that
   * the dialog has been dismissed. This is useful for other components that
   * need to perform additional actions when the dialog is dismissed.
   */
  dismissDialog() {
    this.$dispatch("dialog:dismissed");
    this.closeDialog();
  },

  /**
   * Slides the dialog in by translating it outside of the viewport, then
   * translating it back into the viewport with an inward transition effect.
   */
  slideIn() {
    this.$refs.dialog.classList.add("clio-ui-dialog-initial-translate");

    setTimeout(() => {
      this.$refs.dialog.classList.add("clio-ui-dialog-transition-in");
      this.$refs.dialog.classList.remove("clio-ui-dialog-initial-translate");
    }, 0);
  },

  /**
   * Slides the dialog out and off the right side of the viewport by replacing
   * the original transition into the viewport with an outward transition
   * effect.
   */
  slideOut() {
    this.$refs.dialog.classList.remove("clio-ui-dialog-transition-in");
    this.$refs.dialog.classList.add("clio-ui-dialog-transition-out");

    setTimeout(() => {
      this.$refs.dialog.close();
      this.open = false;
    }, 200);
  },
});
